import type { ButtonHTMLAttributes } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger';
}

const baseStyle = {
  padding: '12px',
  borderRadius: '6px',
  fontSize: '14px',
  fontWeight: 500,
  cursor: 'pointer',
  width: '100%',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
} as const;

const variantStyles = {
  primary: {
    background: 'var(--gradient-cta)',
    color: 'white',
    border: 'none',
  },
  secondary: {
    background: 'var(--color-button-secondary)',
    color: 'var(--color-text-primary)',
    border: 'var(--border-strong)',
  },
  danger: {
    background: 'transparent',
    color: 'var(--color-error-text)',
    border: '0.5px solid rgba(239, 68, 68, 0.4)',
  },
} as const;

export function Button({ variant = 'primary', style, disabled, children, ...rest }: ButtonProps) {
  return (
    <button
      {...rest}
      disabled={disabled}
      style={{
        ...baseStyle,
        ...variantStyles[variant],
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
        ...style,
      }}
    >
      {children}
    </button>
  );
}
